import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { SafeUrl } from '@angular/platform-browser';
import { AvatarModule } from '@avenir-client-web/avatar';
import { User } from '@core/models/profile.model';
import { MenuItem } from 'primeng/api';
import { TieredMenuModule } from 'primeng/tieredmenu';

@Component({
  selector: 'app-header-profile',
  templateUrl: './header-profile.component.html',
  styleUrls: ['./header-profile.component.scss'],
  imports: [CommonModule, TieredMenuModule, AvatarModule],
})
export class HeaderProfileComponent {
  @Input() profile: User;

  @Input() items: MenuItem[] = [];

  @Input() alwaysShowTitle = true;

  @Input() avatarUrl: SafeUrl;
}
